export default __webpack_public_path__ + "static/media/footer.2ed6077f.svg";